import { getStatusText } from "../modules/rfp/enquiryVenueDataStatus";
import React from "react";
let RfpStatus = ({ data }) => {
  return (
    <span className="p-1 my-1 bg-blue-light text-xs font-bold">
      {getStatusText(data.enquiry_venue_datas, data)}
    </span>
  );
};

export default RfpStatus;
